import React, { useState, useRef, useEffect } from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';
import { Search, Filter } from 'lucide-react';

import { ReactComponent as FiSearch } from "../../../../assets/images/search-icon.svg";
import { ReactComponent as FiSliders } from "../../../../assets/images/filters-icon.svg";

const SearchBar = ({ searchTerm, onSearchChange, onSortChange, currentSort }) => {
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const sortOptions = [
    { value: null, label: 'New' },
    { value: 'weekly', label: 'Top (Weekly)' },
    { value: 'monthly', label: 'Top (Monthly)' },
    { value: 'yearly', label: 'Top (Yearly)' },
    { value: 'all', label: 'Top (All Time)' }
  ];

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowFilterDropdown(false);
      }
    };

    if (showFilterDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFilterDropdown]);

  const handleSortSelect = (sortValue) => {
    onSortChange(sortValue);
    setShowFilterDropdown(false);
  };

  return (
    <div className="search-input" style={{ position: 'relative' }}>
      <FiSearch className="icon" />
      <input
        type="text"
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Search by discussion..."
      />
      <div ref={dropdownRef} style={{ position: 'relative', display: 'inline-block' }}>
        <Button
          variant="link"
          onClick={() => setShowFilterDropdown(!showFilterDropdown)}
        >
          <FiSliders className="icon-filter" />
        </Button>

        {/* Filter Dropdown */}
        {showFilterDropdown && (
          <div
            style={{
              position: 'absolute',
              top: '100%',
              right: 0,
              marginTop: '8px',
              backgroundColor: 'white',
              borderRadius: '8px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              minWidth: '200px',
              zIndex: 1000,
              overflow: 'hidden'
            }}
          >
            {sortOptions.map((option, index) => (
              <div
                key={option.value || 'new'}
                onClick={() => handleSortSelect(option.value)}
                style={{
                  padding: '5px 16px',
                  cursor: 'pointer',
                  fontSize: '12px',
                  fontWeight: currentSort === option.value ? '600' : '400',
                  color: currentSort === option.value ? '#0195D3' : '#374151',
                  backgroundColor: currentSort === option.value ? '#f0f9ff' : 'transparent',
                  borderBottom: index < sortOptions.length - 1 ? '1px solid #f3f4f6' : 'none',
                  transition: 'background-color 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  if (currentSort !== option.value) {
                    e.currentTarget.style.backgroundColor = '#f9fafb';
                  }
                }}
                onMouseLeave={(e) => {
                  if (currentSort !== option.value) {
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }
                }}
              >
                {option.label}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchBar;
